import React from 'react';
import './Services.css';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  return (
    <div className="services" id="services">
      <section className="services-section">
        <div className="services-container">
          <h2>{t('services.title')}</h2>
          <div className="services-content">
            <p>{t('services.intro')}</p>
            <div className="services-grid">
              {t('services.serviceCards').map((service, index) => (
                <div key={index} className="service-card">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
